import { Store } from "vuex";
import { Branch, Company, Terminal, RootState } from ".";
import { log, selectOrNull, sleepFor, toNumberID } from "@/util";

export async function selectCompany(store: Store<RootState>, qCompanyID: unknown): Promise<Company> {
  const companyID = toNumberID(qCompanyID);
  if (!store.state.selectedCompany || (!!companyID && store.state.selectedCompany.id !== companyID)) {
    const companies = store.state.userCompanies as Company[];
    if (companies && companies.length > 0) {
      await store.dispatch(
        "selectCompany",
        companies.find((c) => c.id === companyID)
      );
    }
  }
  let timeout = 10000;
  while (store.state.selectedCompanyLoading && timeout > 0) {
    timeout -= 100;
    await sleepFor(100);
  }
  if (!store.state.selectedCompany) {
    throw new Error("Couldn't select company");
  }
  return store.state.selectedCompany;
}

export function searchTerminal(
  branch: Branch | null | undefined,
  terminals: Partial<Terminal>[] | null | undefined,
  code?: string,
  tcod?: string
): Partial<Terminal> | null {
  if (!terminals) return null;

  const resultTerminal = selectOrNull(terminals, (b) => (!!code && b.code == code) || (!!tcod && b.tcod == tcod));
  if (code && !resultTerminal) {
    log("Terminal not found", { code, tcod, in: branch });
  }
  return resultTerminal;
}
